import React from "react";
import { Toaster, toast } from "sonner";
import { GreenThick } from "../assets/icon";

interface ToastProps { }

const Toast: React.FC<ToastProps> = () => {
  return (
    <Toaster
      position="top-right"
      richColors={false}
      closeButton
      toastOptions={{
        classNames: {
          toast: "custom-toast",
          description: "custom-toast-description",
          actionButton: "custom-toast-action",
        },
      }}
    />
  );
};

export const showToast = (
  message: string | undefined,
  status: boolean,
  options?: { includeLoginLink?: boolean }
) => {
  const defaultSuccessMessage = "Operation successful";
  const defaultErrorMessage = "Operation failed";

  toast.custom(
    (t) => (
      <div
        className={`flex items-center justify-between w-[380px] p-4 rounded-xl shadow-md bg-white border`}
      >
        <div className="flex items-start flex-1">
          {status ? (
            <span>
              <GreenThick />
            </span>

          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_1028_2032)">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#FF0000" />
              </g>
              <defs>
                <clipPath id="clip0_1028_2032">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>


          )}
          <div>
            <p className="text-sm text-[#374151] font-medium ml-3">
              {message || (status ? defaultSuccessMessage : defaultErrorMessage)}
            </p>
          </div>
        </div>

        {/* <div className="flex flex-col items-end justify-center gap-1">
          {options?.includeLoginLink && (
            <a
              href="/signin"
              className="text-xs font-medium text-[#0A7BCE] hover:underline"
            >
              Log In
            </a>
          )}
          <button
            onClick={() => toast.dismiss(t)}
            className="text-[#6B7280] text-xs font-medium hover:text-gray-800"
          >
            Close
          </button>
        </div> */}
      </div>
    ),
    {
      duration: 2000,
    }
  );
};

export default Toast;
